import { Link } from "react-router-dom";
import { Trans, useTranslation } from "react-i18next";

import style from "./RegisterPanel.module.css";
import Icon from "@/ui/icon/Icon";
import underline from "@/assets/images/decorative/underline.svg";
import { useLoginWithGoogle } from "@/features/auth/hooks/useLoginWithGoogle";
import { useFreeCourses } from "@/features/courses/hooks/useFreeCourses";
import { useStickyWhenItFits } from "@/features/landing/hooks/useStickyWhenItFits";

function RegisterPanel() {
	const { t } = useTranslation();
	const { loginWithGoogle } = useLoginWithGoogle();
	const { freeOffer } = useFreeCourses();
	const [panelRef, isSticky] = useStickyWhenItFits();

	return (
		<aside
			ref={panelRef}
			className={`${style.panel} ${isSticky ? style.sticky : ""}`}
		>
			<div className={style.glow}></div>

			<div className={style.head}>
				<h3 className={style.title}>{t("auth:prompt.title")}</h3>
				<p className={style.sub}>
					<Trans
						i18nKey="landing:register.unlock"
						values={{ offer: freeOffer }}
						components={{
							marked: <span className={style.marked} />,
							underline: (
								<img
									src={underline}
									alt=""
									className={style.underline}
								/>
							),
						}}
					/>
				</p>
			</div>

			<div className={style.body}>
				<div className={style.buttons}>
					<button
						type="button"
						onClick={loginWithGoogle}
						className={style.option}
					>
						<Icon icon="fa-google" iconType="fa-brands" />
						{t("auth:prompt.withGoogle")}
					</button>
					<Link to="/register" className={style.option}>
						<Icon icon="fa-envelope" />
						{t("auth:prompt.withEmail")}
					</Link>
				</div>

				<div className={style.divider}>
					<span></span>
					{t("common:divider.or")}
					<span></span>
				</div>

				<div className={style.existing}>
					<p>{t("auth:prompt.haveAccount")}</p>
					<Link to="/login" className={style.option}>
						<Icon icon="fa-user" />
						{t("common:nav.login")}
					</Link>
				</div>
			</div>
		</aside>
	);
}

export default RegisterPanel;
